import React from "react";
import { useLocation, Link } from "react-router-dom";
import { Breadcrumb } from "antd";

const BreadCrumb = () => {
  const location = useLocation();

  const getReadableName = (segment) => {
    switch (segment) {
      case "dashboard":
        return "Dashboard";
      case "list-barang":
        return "Data Pengiriman";
      case "list-customer":
        return "Data Customer";
      case "list-karyawan":
        return "Staff Admin";
      case "admin":
        return "Admin";
      default:
        return segment.charAt(0).toUpperCase() + segment.slice(1);
    }
  };

  const { pathname } = location;
  const rawSegments = pathname.split("/").filter(Boolean);
  // Filter out 'admin' if it's the prefix to avoid redundant "Admin / Dashboard / ..."
  const segments = rawSegments.filter((seg) => seg !== "admin");

  return (
    <div className="admin-breadcrumb-wrapper" style={{ display: "flex", alignItems: "center" }}>
      <Breadcrumb
        items={[
          {
            title: <Link to="/admin/dashboard" style={{ color: "#64748b" }}>Admin</Link>
          },
          ...segments.map((seg, idx) => {
            const isLast = idx === segments.length - 1;
            return {
              title: isLast ? (
                <strong style={{ color: "#0f172a" }}>{getReadableName(seg)}</strong>
              ) : (
                <Link to={`/admin/${seg}`} style={{ color: "#64748b" }}>
                  {getReadableName(seg)}
                </Link>
              )
            };
          })
        ]}
      />
    </div>
  );
};

export default BreadCrumb;